var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9823 0.52533C8.04025 0.52533 8.53614 3.95035 8.53614 3.95035L8.54496 7.49877H16.1239V8.5641H5.53471C5.53471 8.5641 0.452576 7.99093 0.452576 15.9599C0.452576 23.9291 4.88839 23.6465 4.88839 23.6465H7.53566V19.9485C7.53566 19.9485 7.39295 15.5373 11.9007 15.5373H19.4177C19.4177 15.5373 23.6409 15.6052 23.6409 11.4783V4.65484C23.6409 4.65484 24.2823 0.52533 15.9823 0.52533ZM11.8033 2.91157C11.9824 2.91141 12.1597 2.94637 12.3252 3.01446C12.4907 3.08254 12.6411 3.18241 12.7677 3.30834C12.8944 3.43428 12.9948 3.58381 13.0633 3.74839C13.1317 3.91296 13.1669 4.08935 13.1667 4.26745C13.1669 4.44555 13.1317 4.62193 13.0633 4.78651C12.9948 4.95108 12.8944 5.10062 12.7677 5.22655C12.6411 5.35249 12.4907 5.45236 12.3252 5.52044C12.1597 5.58852 11.9824 5.62348 11.8033 5.62332C11.6242 5.62348 11.4468 5.58852 11.2813 5.52044C11.1158 5.45236 10.9655 5.35249 10.8388 5.22655C10.7122 5.10062 10.6117 4.95108 10.5433 4.78651C10.4748 4.62193 10.4397 4.44555 10.4398 4.26745C10.4397 4.08935 10.4748 3.91296 10.5433 3.74839C10.6117 3.58381 10.7122 3.43428 10.8388 3.30834C10.9655 3.18241 11.1158 3.08254 11.2813 3.01446C11.4468 2.94637 11.6242 2.91141 11.8033 2.91157Z",
    fill: "url(#paint0_linear_1_6347)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2079 31.4747C24.1499 31.4747 23.6541 28.0496 23.6541 28.0496L23.6452 24.5013H16.0661V23.436H26.6554C26.6554 23.436 31.7375 24.0092 31.7375 16.04C31.7375 8.07085 27.3017 8.35347 27.3017 8.35347H24.6544V12.0514C24.6544 12.0514 24.7971 16.4626 20.2894 16.4626H12.7724C12.7724 16.4626 8.54915 16.3947 8.54915 20.5217V27.3453C8.54915 27.3453 7.90785 31.4747 16.2078 31.4747H16.2079ZM20.3869 29.0887C20.2078 29.0888 20.0305 29.0539 19.865 28.9858C19.6995 28.9177 19.5491 28.8178 19.4225 28.6919C19.2958 28.566 19.1954 28.4164 19.1269 28.2518C19.0585 28.0873 19.0233 27.9109 19.0235 27.7328C19.0233 27.5547 19.0584 27.3783 19.1269 27.2137C19.1953 27.0491 19.2958 26.8995 19.4224 26.7736C19.5491 26.6476 19.6994 26.5478 19.8649 26.4797C20.0304 26.4116 20.2078 26.3766 20.3869 26.3768C20.566 26.3766 20.7434 26.4116 20.9089 26.4797C21.0744 26.5477 21.2247 26.6476 21.3514 26.7736C21.478 26.8995 21.5785 27.049 21.6469 27.2136C21.7154 27.3782 21.7505 27.5546 21.7504 27.7327C21.7505 27.9108 21.7154 28.0871 21.6469 28.2517C21.5785 28.4163 21.478 28.5658 21.3514 28.6918C21.2247 28.8177 21.0744 28.9176 20.9089 28.9857C20.7434 29.0537 20.566 29.0887 20.3869 29.0885V29.0887Z",
    fill: "url(#paint1_linear_1_6347)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_6347",
    x1: 3.45904,
    y1: 3.30903,
    x2: 18.8774,
    y2: 18.6588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_6347",
    x1: 12.9753,
    y1: 13.1106,
    x2: 29.5371,
    y2: 28.8544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.e1db1d37b8c850697b9de9180c92b4a2.svg";
export { ForwardRef as ReactComponent };